import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompanyGroupEffects } from './company-group.effects';
import { ICompanyGroupFeature } from './company-group.feature.state';
import { CompanyGroupReducer } from './company-group.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ICompanyGroupFeature>('CompanyGroupFeature'), CompanyGroupReducer),
    EffectsModule.forFeature([CompanyGroupEffects]),
  ],
})
export class CompanyGroupStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: CompanyGroupStateModule
  ) {
    if (parentModule) {
      throw new Error('CompanyGroupStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
